"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2393,2912],{

/***/ 62912:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(14924);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _contentful_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74129);
/* harmony import */ var _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86437);
/* harmony import */ var _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(70917);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37337);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(46523);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(22470);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(76614);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(86872);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(61442);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(26029);
/* harmony import */ var _opendoor_bricks_theme__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(81821);
/* harmony import */ var helpers_i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71899);
/* harmony import */ var _cms_utils__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(46000);
/* harmony import */ var _Container__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93524);
/* harmony import */ var _motion_MotionVariants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(81931);
/* harmony import */ var _styles_ComponentTheme__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12090);















var OpendoorIconLogo = function() {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "22",
        height: "30",
        viewBox: "0 0 22 30",
        fill: "none",
        style: {
            position: "absolute",
            top: 0,
            left: 0
        },
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("title", {
                children: "Opendoor Icon Logo"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("g", {
                clipPath: "url(#clip0_1_54)",
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M15.2462 11.5378C15.2462 4.44667 14.0271 1.50727 10.6755 1.50727C7.71982 1.50727 6.22677 3.56782 6.22677 10.7197C6.22677 17.7806 7.3847 20.6898 10.7974 20.6898C13.814 20.6898 15.2462 18.6593 15.2462 11.5378ZM0.4375 11.3561C0.4375 3.38602 5.95262 0.234375 10.8584 0.234375C16.0992 0.234375 21.0353 3.35581 21.0353 10.8712C21.0353 18.9018 15.5203 21.9627 10.6145 21.9627C5.37372 21.9627 0.4375 18.6292 0.4375 11.3561ZM19.9597 28.3745C19.4596 27.7147 17.5333 25.1732 17.5333 25.1732C17.3526 24.9347 17.0429 24.7908 16.7105 24.7908H4.76234C4.42997 24.7908 4.12027 24.9347 3.93954 25.1732L1.51348 28.374C1.43651 28.4755 1.39567 28.5937 1.39567 28.7145V29.2031C1.39567 29.366 1.52843 29.498 1.69226 29.498H19.7806C19.9444 29.498 20.0772 29.366 20.0772 29.2031V28.7145C20.0772 28.5937 20.0367 28.4758 19.9597 28.3745Z",
                    fill: "currentColor"
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("defs", {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("clipPath", {
                    id: "clip0_1_54",
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("rect", {
                        width: "20.7284",
                        height: "29.2637",
                        fill: "white",
                        transform: "translate(0.4375 0.234375)"
                    })
                })
            })
        ]
    });
};
var FooterLinkColumn = function(param) {
    var text = param.text, url = param.url;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Box */ .x, {
        tag: "li",
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__/* .Link */ .r, {
            analyticsName: "footer-link-column-".concat(text),
            typography: "$bodyMedium",
            href: url,
            //Updating Variant for Dark background
            variant: "secondaryInverse",
            style: {
                textDecoration: "none"
            },
            children: text
        })
    });
};
var FooterSellInYourMarket = function(param) {
    var sellInYourMarket = param.sellInYourMarket, theme = param.theme;
    var t = (0,helpers_i18n__WEBPACK_IMPORTED_MODULE_4__/* .useT */ .NT)().t;
    if (!(sellInYourMarket === null || sellInYourMarket === void 0 ? void 0 : sellInYourMarket.length)) {
        return null;
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Box */ .x, {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        width: "100%",
        padding: "$5x",
        backgroundColor: theme.bgPrimaryLight,
        $smallerThanMD: {
            flexDirection: "column"
        },
        borderRadius: "$6x",
        gap: "$4x",
        overflow: "hidden",
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11__/* .Text */ .x, {
                tag: "p",
                style: {
                    minWidth: "10ch",
                    flexShrink: 0
                },
                typography: "$labelSmall",
                color: theme.contentPrimary,
                children: t("homepage.links.sell-in-your-market", "Learn about selling in your market")
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Box */ .x, {
                display: "flex",
                gap: "$4x",
                flexDirection: "row",
                flexWrap: "wrap",
                alignItems: "center",
                flex: 1,
                minWidth: 0,
                $smallerThanMD: {
                    justifyContent: "center"
                },
                children: sellInYourMarket.map(function(market, i) {
                    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .Fragment */ .HY, {
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(FooterLinkColumn, {
                                text: market.label,
                                url: "/sell/".concat(market.path)
                            }, market.path),
                            i < sellInYourMarket.length - 1 && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Box */ .x, {
                                tag: "span",
                                children: "|"
                            })
                        ]
                    });
                })
            })
        ]
    });
};
var Footer = function(param) {
    var _backgroundColor = param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? _styles_ComponentTheme__WEBPACK_IMPORTED_MODULE_7__/* .BNColorThemes.Grey */ .CW.Grey : _backgroundColor, footerImage = param.footerImage, footerImageTitle = param.footerImageTitle, footerNav = param.footerNav, footerTitle = param.footerTitle, sellInYourMarket = param.sellInYourMarket, googlePlaystoreLink = param.googlePlaystoreLink, appleStoreLink = param.appleStoreLink, helpCenterLink = param.helpCenterLink, extraLegalText = param.extraLegalText, showCustomerTestimonialLegal = param.showCustomerTestimonialLegal, showEligibilityLegal = param.showEligibilityLegal, showPromotionLegal = param.showPromotionLegal, showThePdpCopyrightLegal = param.showThePdpCopyrightLegal, locale = param.locale;
    var t = (0,helpers_i18n__WEBPACK_IMPORTED_MODULE_4__/* .useT */ .NT)().t;
    var theme = (0,_styles_ComponentTheme__WEBPACK_IMPORTED_MODULE_7__/* .getBNComponentThemeColors */ .u$)(backgroundColor in _styles_ComponentTheme__WEBPACK_IMPORTED_MODULE_7__/* .BNColorThemes */ .CW ? backgroundColor : _styles_ComponentTheme__WEBPACK_IMPORTED_MODULE_7__/* .BNColorThemes.Grey */ .CW.Grey);
    var appleStoreImageUrl = locale === "es" ? "https://images.opendoor.com/source/s3/imgdrop-production/2025-06-1750894044413-61865.png?preset=square-2048" : "https://images.opendoor.com/source/s3/imgdrop-production/2023-12-1702502078078-95093.png?preset=square-2048";
    var googlePlayStoreImageUrl = locale === "es" ? "https://images.opendoor.com/source/s3/imgdrop-production/2025-06-1750894682317-95550.png?preset=square-2048" : "https://images.opendoor.com/source/s3/imgdrop-production/2023-12-1702502078081-28903.png?preset=square-2048";
    var buttonBg = "warmgrey950";
    var buttonColor = "white0";
    var buttonHoverBg = "warmgrey800";
    var buttonActiveBg = "warmgrey800";
    var ArchImage = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
        target: "e1p59det0"
    })({
        objectFit: "cover",
        width: "100%",
        height: "100%",
        borderRadius: "99em 99em 8em 8em"
    });
    var FooterForegroundBox = function(param) {
        var children = param.children, title = param.title, _isAppButtonFooter = param.isAppButtonFooter, isAppButtonFooter = _isAppButtonFooter === void 0 ? false : _isAppButtonFooter;
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Box */ .x, {
            display: "flex",
            flex: 1,
            justifyContent: "space-between",
            flexDirection: isAppButtonFooter ? "column" : "row",
            $largerThanSM: {
                flexDirection: "row"
            },
            width: "100%",
            padding: "$5x",
            backgroundColor: theme.bgPrimaryLight,
            borderRadius: (0,_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_13__.getToken)("$6x", "radius"),
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11__/* .Text */ .x, {
                    tag: "p",
                    flex: 1,
                    style: {
                        minWidth: "10ch"
                    },
                    typography: "$labelSmall",
                    color: theme.contentPrimary,
                    children: title
                }),
                children
            ]
        });
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Box */ .x, {
        tag: "footer",
        backgroundColor: theme.bgPrimary,
        // @ts-expect-error TODO
        color: theme.contentPrimary,
        paddingVertical: "$12x",
        minHeight: 450,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_Container__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Box */ .x, {
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "flex-end",
                    $largerThanSM: {
                        alignItems: "center",
                        gap: "$20x"
                    },
                    justifyContent: "space-between",
                    gap: "$8x",
                    position: "relative",
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(OpendoorIconLogo, {}),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11__/* .Text */ .x, {
                            tag: "h2",
                            typography: "$subheaderMedium",
                            $largerThanSM: {
                                typography: "$headerLarge"
                            },
                            // @ts-expect-error TODO
                            maxWidth: "10ch",
                            color: theme.contentPrimary,
                            width: "100%",
                            children: footerTitle
                        }),
                        footerImage && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Box */ .x, {
                            maxWidth: 180,
                            $largerThanSM: {
                                maxWidth: 325,
                                height: 440
                            },
                            height: 264,
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(ArchImage, {
                                src: footerImage,
                                alt: footerImageTitle || "",
                                loading: "lazy"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Box */ .x, {
                    display: "flex",
                    justifyContent: "flex-end",
                    $largerThanMD: {
                        marginLeft: 320
                    },
                    marginTop: 80,
                    marginBottom: "$12x",
                    flexDirection: "column",
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Box */ .x, {
                            display: "flex",
                            gap: "$8x",
                            flexWrap: "wrap",
                            $largerThanSM: {
                                flexWrap: "nowrap"
                            },
                            flexDirection: "row",
                            marginBottom: "$16x",
                            children: footerNav && footerNav.map(function(navItem, i) {
                                var ref;
                                var ref1;
                                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Box */ .x, {
                                    flex: 1,
                                    flexBasis: "45%",
                                    children: [
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11__/* .Text */ .x, {
                                            tag: "h3",
                                            typography: "$subheaderSmall",
                                            color: theme.contentPrimary,
                                            marginBottom: "$12x",
                                            children: navItem.fields.title
                                        }),
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Box */ .x, {
                                            tag: "ul",
                                            padding: 0,
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "$8x",
                                            children: ((ref1 = (ref = navItem.fields.links) === null || ref === void 0 ? void 0 : ref.filter(function(link) {
                                                return link != null && (0,_cms_utils__WEBPACK_IMPORTED_MODULE_14__/* .isSimpleLink */ .$)(link);
                                            })) !== null && ref1 !== void 0 ? ref1 : []).map(function(link, i) {
                                                var url = link.fields.url || "";
                                                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(FooterLinkColumn, {
                                                    text: link.fields.text || "",
                                                    url: url
                                                }, i);
                                            })
                                        })
                                    ]
                                }, i);
                            })
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(FooterSellInYourMarket, {
                            sellInYourMarket: sellInYourMarket,
                            theme: theme
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Box */ .x, {
                            $largerThanSM: {
                                flexDirection: "row"
                            },
                            marginTop: "$8x",
                            gap: "$8x",
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(FooterForegroundBox, {
                                    title: t("homepage.links.app", "Get the app"),
                                    isAppButtonFooter: true,
                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Box */ .x, {
                                        display: "flex",
                                        flex: 1,
                                        flexWrap: "wrap",
                                        flexDirection: "row",
                                        gap: "$4x",
                                        paddingTop: "$2x",
                                        $largerThanSM: {
                                            paddingTop: undefined,
                                            justifyContent: "flex-end"
                                        },
                                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv)("flex-direction:column;@media (min-width:440px){flex-direction:row;}@media (min-width:768px){flex-direction:column;}@media (min-width:874px){flex-direction:row;}"),
                                        children: [
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__/* .Link */ .r, {
                                                href: appleStoreLink,
                                                "aria-label": "Opendoor Applestore button",
                                                hoverStyle: {
                                                    color: theme.contentPrimary
                                                },
                                                color: theme.contentPrimary,
                                                analyticsName: "cosmos-landing-page-v2-footer-applesotre-button",
                                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                                    src: appleStoreImageUrl,
                                                    loading: "lazy",
                                                    alt: "Opendoor Applestore",
                                                    width: 135,
                                                    height: 45
                                                })
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__/* .Link */ .r, {
                                                href: googlePlaystoreLink,
                                                "aria-label": "Opendoor Google play button",
                                                hoverStyle: {
                                                    color: theme.contentPrimary
                                                },
                                                color: theme.contentPrimary,
                                                analyticsName: "cosmos-landing-page-v2-footer-googlgplay-button",
                                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                                    src: googlePlayStoreImageUrl,
                                                    loading: "lazy",
                                                    alt: "Opendoor Google Play",
                                                    width: locale === "es" ? 150 : 135,
                                                    height: 45
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(FooterForegroundBox, {
                                    title: t("homepage.titles.questions", "Still have questions?"),
                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .ZP, {
                                        as: "a",
                                        type: "submit",
                                        href: helpCenterLink,
                                        "aria-label": "Opendoor Help Center button",
                                        analyticsName: "cosmos-landing-page-v2-footer-help-center",
                                        bg: buttonBg,
                                        color: buttonColor,
                                        alignItems: "center",
                                        display: "inline-flex",
                                        fontSize: "14px",
                                        letterSpacing: "-1.4",
                                        pb: "8px",
                                        pt: "8px",
                                        minHeight: "45px",
                                        maxHeight: "45px",
                                        textAlign: "center",
                                        width: "fit-content",
                                        position: "relative",
                                        overflow: "hidden",
                                        _after: {
                                            aspectRatio: "1 / 1",
                                            backgroundColor: buttonHoverBg,
                                            content: '""',
                                            display: "block",
                                            borderRadius: "99em 99em 10em 10em",
                                            left: "0",
                                            position: "absolute",
                                            top: "100%",
                                            transform: "scale(0.5)",
                                            transition: "0.5s ".concat(_motion_MotionVariants__WEBPACK_IMPORTED_MODULE_6__/* .defaultEaseCss */ .qc, " transform"),
                                            width: "100%"
                                        },
                                        _hover: {
                                            backgroundColor: buttonBg,
                                            color: buttonColor
                                        },
                                        _focusVisible: {
                                            backgroundColor: buttonHoverBg
                                        },
                                        _active: {
                                            backgroundColor: buttonActiveBg
                                        },
                                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv)("border-radius:", _opendoor_bricks_theme__WEBPACK_IMPORTED_MODULE_17__/* .novo.radii.roundedSquare */ .hI.radii.roundedSquare, ";transition:0.3s ", _motion_MotionVariants__WEBPACK_IMPORTED_MODULE_6__/* .defaultEaseCss */ .qc, " background-color;will-change:transform;&:after{will-change:transform;}@media (hover:hover) and (pointer:fine){&:hover:after{transform:translate3d(0,-100%,0) scale(2);}}"),
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Box */ .x, {
                                            tag: "span",
                                            zIndex: 5,
                                            children: t("homepage.links.helpCenter", "Visit the Help Center")
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Box */ .x, {
                            backgroundColor: theme.bgPrimaryLight,
                            borderRadius: "$6x",
                            marginTop: "$8x",
                            padding: "$8x",
                            // @ts-expect-error expect TODO
                            color: "$contentPrimary",
                            children: [
                                extraLegalText && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Box */ .x, {
                                    marginBottom: "$12x",
                                    css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv)("* + *{margin-top:16px;}"),
                                    // @ts-expect-error dynamic children inherit this color
                                    color: theme.contentPrimary,
                                    children: (0,_contentful_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_1__/* .documentToReactComponents */ .h)(extraLegalText, {
                                        renderNode: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({}, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.INLINES.HYPERLINK, function(node, children) {
                                            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__/* .Link */ .r, {
                                                href: node.data.uri,
                                                analyticsName: "cosmos-footer",
                                                "aria-label": "",
                                                hoverStyle: {
                                                    color: theme.contentPrimary
                                                },
                                                color: theme.contentPrimary,
                                                textDecorationLine: "underline",
                                                children: children
                                            });
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11__/* .Text */ .x, {
                                    tag: "p",
                                    typography: "$bodyMedium",
                                    color: theme.contentPrimary,
                                    css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv)("* + *{margin-bottom:16px;}"),
                                    children: [
                                        showEligibilityLegal && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .Fragment */ .HY, {
                                            children: [
                                                "Offer eligibility and purchase price vary.",
                                                " "
                                            ]
                                        }),
                                        showCustomerTestimonialLegal && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .Fragment */ .HY, {
                                            children: [
                                                "Featured customers may have been compensated for their time. Their opinions and views are solely their own.",
                                                " "
                                            ]
                                        }),
                                        showThePdpCopyrightLegal && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .Fragment */ .HY, {
                                            children: [
                                                "Data is subject to copyright, and provided solely for personal, not commercial use. All property information should be verified by the recipient and none is guaranteed as accurate.",
                                                " "
                                            ]
                                        }),
                                        showPromotionLegal && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .Fragment */ .HY, {
                                            children: [
                                                "Eligibility may vary. Not all promotions may be combined.",
                                                " "
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11__/* .Text */ .x, {
                                    tag: "p",
                                    typography: "$bodyMedium",
                                    display: "inline",
                                    color: theme.contentPrimary,
                                    children: "CA: Opendoor Brokerage Inc. DRE #02061130"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11__/* .Text */ .x, {
                                    tag: "p",
                                    typography: "$bodyMedium",
                                    display: "inline",
                                    color: theme.contentPrimary,
                                    children: [
                                        "NY:",
                                        " ",
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__/* .Link */ .r, {
                                            analyticsName: "cosmos-landing-page-v2-footer-legal-link",
                                            "aria-label": "Licensed as Opendoor Brokerage LLC pdf link",
                                            href: "https://s3.amazonaws.com/odfil.es/static/documents/Dan+NY+Notarized+Doc.pdf",
                                            hoverStyle: {
                                                color: theme.contentPrimary
                                            },
                                            color: theme.contentPrimary,
                                            textDecorationLine: "underline",
                                            children: "Licensed as Opendoor Brokerage LLC"
                                        }),
                                        ",",
                                        " ",
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__/* .Link */ .r, {
                                            analyticsName: "cosmos-landing-page-v2-footer-legal-link",
                                            "aria-label": "Fair Housing Notice pdf link",
                                            href: "https://s3.amazonaws.com/odfil.es/static/documents/fair-housing-notice.pdf",
                                            hoverStyle: {
                                                color: theme.contentPrimary
                                            },
                                            color: theme.contentPrimary,
                                            textDecorationLine: "underline",
                                            children: "Fair Housing Notice"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11__/* .Text */ .x, {
                                    tag: "p",
                                    display: "inline",
                                    typography: "$bodyMedium",
                                    color: theme.contentPrimary,
                                    children: [
                                        "TX:",
                                        " ",
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__/* .Link */ .r, {
                                            analyticsName: "cosmos-landing-page-v2-footer-legal-link",
                                            "aria-label": "TREC Information About Brokerage Services pdf link",
                                            href: "https://odfil.es/static/IABS_Jan_2026.pdf",
                                            hoverStyle: {
                                                color: theme.contentPrimary
                                            },
                                            color: theme.contentPrimary,
                                            textDecorationLine: "underline",
                                            children: "TREC Information About Brokerage Services"
                                        }),
                                        ",",
                                        " ",
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__/* .Link */ .r, {
                                            analyticsName: "cosmos-landing-page-v2-footer-legal-link",
                                            "aria-label": "TREC Consumer Protection Notice pdf link",
                                            href: "https://www.trec.texas.gov/forms/consumer-protection-notice",
                                            hoverStyle: {
                                                color: theme.contentPrimary
                                            },
                                            color: theme.contentPrimary,
                                            textDecorationLine: "underline",
                                            children: "TREC Consumer Protection Notice"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11__/* .Text */ .x, {
                                    tag: "p",
                                    display: "inline",
                                    typography: "$bodyMedium",
                                    color: theme.contentPrimary,
                                    mt: "$13x",
                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .Fragment */ .HY, {
                                        children: [
                                            "Opendoor Labs Inc. is dedicated to improving the accessibility of its Website and we view accessibility as a continually ongoing effort. Please contact us at",
                                            " ",
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__/* .Link */ .r, {
                                                href: "mailto:support@opendoor.com",
                                                "aria-label": "Contact support link",
                                                analyticsName: "cosmos-contact-opendoor-email",
                                                hoverStyle: {
                                                    color: theme.contentPrimary
                                                },
                                                color: theme.contentPrimary,
                                                textDecorationLine: "underline",
                                                children: "support@opendoor.com"
                                            }),
                                            " ",
                                            "with any support needs, feedback or suggestions."
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Box */ .x, {
                            display: "flex",
                            marginTop: "$40x",
                            alignItems: "center",
                            gap: "$8x",
                            flexDirection: "row",
                            flexWrap: "wrap",
                            $largerThanSM: {
                                justifyContent: "flex-start"
                            },
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11__/* .Text */ .x, {
                                    tag: "span",
                                    typography: "$bodyMedium",
                                    color: theme.contentPrimary,
                                    children: [
                                        "\xa9 ",
                                        new Date().getFullYear(),
                                        " Opendoor | All rights reserved."
                                    ]
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Box */ .x, {
                                    flexDirection: "row",
                                    gap: "$8x",
                                    alignItems: "center",
                                    // @ts-expect-error theme.color is a Token.
                                    color: theme.contentPrimary,
                                    children: [
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                            src: "https://images.opendoor.com/source/s3/imgdrop-production/f2398a1e83a24962a9297d13f2ac6ea5.png?preset=square-2048",
                                            loading: "lazy",
                                            alt: "Equal Housing Opportunity",
                                            width: 38,
                                            height: 38
                                        }),
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__/* .Link */ .r, {
                                            href: "https://www.bbb.org/us/az/tempe/profile/real-estate-services/opendoor-1126-1000060421/#sealclick",
                                            analyticsName: "cosmos-landing-page-v2-footer-bbb-link",
                                            "aria-label": "Better Business Bureau accredited since June 8th 2021 link",
                                            hoverStyle: {
                                                color: theme.contentPrimary
                                            },
                                            color: theme.contentPrimary,
                                            textDecorationLine: "underline",
                                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                                src: "https://images.opendoor.com/source/s3/imgdrop-production/1cd65eee0b8345689ceff0292986f125.png?preset=square-2048",
                                                loading: "lazy",
                                                alt: "Better Business Bureau",
                                                height: 38
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Footer);


/***/ }),

/***/ 86230:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ MapMarker; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97582);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_map_gl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61108);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70917);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86872);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2267);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(46523);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(76614);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(35033);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(97009);
/* harmony import */ var components_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67945);
/* harmony import */ var _property_helpers__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(38298);









function formatNumber(number) {
    return number.toLocaleString("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: number >= 1000000 ? 2 : 0,
        notation: "compact",
        compactDisplay: "short"
    });
}
var PRIMARY_PHOTO_WIDTH = 350;
var PRIMARY_PHOTO_HEIGHT = 150;
var SECONDARY_PHOTO_WIDTH = 172;
var SECONDARY_PHOTO_HEIGHT = 100;
var THUMBNAIL_PARAMS = new URLSearchParams({
    service: "cosmos",
    preset: "3:2-xs"
}).toString();
var MapMarker = function(param) {
    var property = param.property, onClick = param.onClick, moveToTop = param.moveToTop, detailCache = param.detailCache, markerIndex = param.index, focusTopMarker = param.setFocused, isSelected = param.isSelected, isLoading = param.isLoading;
    var ref, ref1, ref2, ref3, ref4;
    var media = (0,_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__.useMedia)();
    var isDesktop = media.largerThanSM;
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isHovering = ref5[0], setIsHovering = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isFocused = ref6[0], setIsFocused = ref6[1];
    var isActive = isHovering || isFocused || isSelected || isLoading;
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), propertyDetails = ref7[0], setPropertyDetails = ref7[1];
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]), imageUrls = ref8[0], setImageUrls = ref8[1];
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), imagesLoaded = ref9[0], setImagesLoaded = ref9[1];
    var ref10 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), pressableRef = ref10[0], setPressableRef = ref10[1];
    var fetchMemoizedPropertyDetails = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
        var fetchPropertyDetails, token;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            fetchPropertyDetails = function() {
                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                    var ref, result;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0,components_api__WEBPACK_IMPORTED_MODULE_2__/* .getAthenaClient */ .k8)().GetMarketplacePropertyDetailsForMapMarkers({
                                        addressToken: property.addressToken
                                    })
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    (result === null || result === void 0 ? void 0 : (ref = result.marketplace) === null || ref === void 0 ? void 0 : ref.property) || null
                                ];
                        }
                    });
                });
                return function fetchPropertyDetails() {
                    return _ref.apply(this, arguments);
                };
            }();
            token = property.addressToken;
            if (!detailCache.current.has(token)) {
                detailCache.current.set(token, fetchPropertyDetails());
            }
            return [
                2,
                detailCache.current.get(token)
            ];
        });
    }), [
        property.addressToken
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (focusTopMarker && pressableRef) {
            pressableRef.focus();
        }
    }, [
        pressableRef
    ]);
    var preparePopup = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
            var details, ref, ref1;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetchMemoizedPropertyDetails()
                        ];
                    case 1:
                        details = _state.sent();
                        if (imageUrls.length === 0) {
                            ;
                            ;
                            setImageUrls((ref1 = details === null || details === void 0 ? void 0 : (ref = details.photos) === null || ref === void 0 ? void 0 : ref.slice(0, 3).map(function(url) {
                                return "".concat(url, "?").concat(THUMBNAIL_PARAMS);
                            })) !== null && ref1 !== void 0 ? ref1 : []);
                        }
                        setPropertyDetails(details);
                        return [
                            2
                        ];
                }
            });
        });
        return function preparePopup() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleOnHover = function() {
        setIsHovering(true);
        moveToTop === null || moveToTop === void 0 ? void 0 : moveToTop(isFocused);
        preparePopup();
    };
    var handleOnFocus = function() {
        moveToTop === null || moveToTop === void 0 ? void 0 : moveToTop(true);
        setIsFocused(true);
        preparePopup();
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        imageUrls.map(function(url) {
            var image = new Image();
            image.onload = function() {
                setImagesLoaded(function(value) {
                    return value + 1;
                });
            };
            image.src = url;
        });
    }, [
        imageUrls
    ]);
    var handleOnMouseOut = function() {
        setIsHovering(false);
    };
    var handleOnBlur = function() {
        setIsFocused(false);
    };
    var handleOnClick = function() {
        setIsHovering(false);
        setIsFocused(false);
        onClick();
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .Global */ .xB, {
                styles: [
                    (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(".mapboxgl-popup-tip{display:none;}.mapboxgl-popup-content{width:350px;height:360px;padding:0 0 0 0px;border-radius:15px !important;right:50px;}.mapboxgl.popup{border-radius:15px !important;}.mapboxgl-marker:hover{z-index:1000;}")
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(react_map_gl__WEBPACK_IMPORTED_MODULE_1__/* .Marker */ .Jx, {
                latitude: (ref = property.location) === null || ref === void 0 ? void 0 : ref.lat,
                longitude: (ref1 = property.location) === null || ref1 === void 0 ? void 0 : ref1.lon,
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__/* .PressableBox */ .K, {
                        "aria-label": "Property marker",
                        analyticsName: "property-marker-click",
                        backgroundColor: isActive ? "$backgroundInversePrimary" : "$backgroundPrimary",
                        borderRadius: "$32x",
                        height: 28,
                        width: (property === null || property === void 0 ? void 0 : property.isLiked) ? 76 : 60,
                        zIndex: 1,
                        tabIndex: markerIndex + 10,
                        justifyContent: "center",
                        alignItems: "center",
                        onMouseEnter: handleOnHover,
                        onMouseLeave: handleOnMouseOut,
                        onFocus: handleOnFocus,
                        onBlur: handleOnBlur,
                        onPress: handleOnClick,
                        ref: function(ref) {
                            return setPressableRef(ref);
                        },
                        "data-testid": "map-marker-".concat(property.addressToken),
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Box */ .x, {
                            flexDirection: "row",
                            alignItems: "flex-start",
                            children: isLoading ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__/* .Text */ .x, {
                                tag: "span",
                                typography: "$labelSmall",
                                color: "$contentInversePrimary",
                                children: "•••"
                            }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .Fragment */ .HY, {
                                children: [
                                    (property === null || property === void 0 ? void 0 : property.isLiked) && // size={14} is valid at runtime but bricks-next strictly types as 20|24 for style / no particular reason
                                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                    // @ts-ignore
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                        size: 14,
                                        color: "$contentStateErrorDefault",
                                        pr: 4
                                    }),
                                    property.listPrice && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__/* .Text */ .x, {
                                        tag: "span",
                                        typography: "$labelSmall",
                                        color: isActive ? "$contentInversePrimary" : "$contentPrimary",
                                        children: "".concat(formatNumber(property.listPrice))
                                    })
                                ]
                            })
                        })
                    }),
                    isActive && isDesktop && imagesLoaded >= 3 && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(react_map_gl__WEBPACK_IMPORTED_MODULE_1__/* .Popup */ .GI, {
                        longitude: (ref2 = property.location) === null || ref2 === void 0 ? void 0 : ref2.lon,
                        latitude: (ref3 = property.location) === null || ref3 === void 0 ? void 0 : ref3.lat,
                        anchor: "bottom",
                        offset: 20,
                        closeButton: false,
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_12__/* .Image */ .E, {
                                alt: "map-marker-primary-property-image",
                                source: {
                                    height: PRIMARY_PHOTO_HEIGHT,
                                    uri: imageUrls[0],
                                    width: PRIMARY_PHOTO_WIDTH
                                },
                                borderTopRightRadius: "$8x",
                                borderTopLeftRadius: "$8x"
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Box */ .x, {
                                flexDirection: "row",
                                justifyContent: "space-between",
                                mt: 6,
                                children: [
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_12__/* .Image */ .E, {
                                        alt: "map-marker-secondary-property-image",
                                        source: {
                                            height: SECONDARY_PHOTO_HEIGHT,
                                            uri: imageUrls[1],
                                            width: SECONDARY_PHOTO_WIDTH
                                        }
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_12__/* .Image */ .E, {
                                        alt: "map-marker-tertiary-property-image",
                                        source: {
                                            height: SECONDARY_PHOTO_HEIGHT,
                                            uri: imageUrls[2],
                                            width: SECONDARY_PHOTO_WIDTH
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Box */ .x, {
                                flexDirection: "row",
                                mt: 24,
                                alignItems: "baseline",
                                mx: 20,
                                justifyContent: "space-between",
                                children: [
                                    property.listPrice && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__/* .Text */ .x, {
                                        typography: "$labelXlarge",
                                        tag: "p",
                                        children: "$".concat(property.listPrice.toLocaleString())
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__/* .Text */ .x, {
                                        typography: "$bodySmall",
                                        tag: "span",
                                        color: "$contentTertiary",
                                        ml: -24,
                                        children: [
                                            "$".concat(propertyDetails === null || propertyDetails === void 0 ? void 0 : (ref4 = propertyDetails.estimatedMonthlyPayment) === null || ref4 === void 0 ? void 0 : ref4.toLocaleString()),
                                            "/month est."
                                        ]
                                    }),
                                    (property === null || property === void 0 ? void 0 : property.isLiked) && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                        // @ts-ignore
                                        size: 14,
                                        color: "$contentStateErrorDefault",
                                        justifySelf: "flex-end",
                                        alignSelf: "baseline"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Box */ .x, {
                                flexDirection: "row",
                                alignItems: "baseline",
                                width: "100%",
                                mt: 12,
                                mx: 20,
                                children: [
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__/* .Text */ .x, {
                                        tag: "span",
                                        typography: "$bodySmall",
                                        color: "$contentTertiary",
                                        children: (propertyDetails === null || propertyDetails === void 0 ? void 0 : propertyDetails.bedrooms) && "".concat(propertyDetails === null || propertyDetails === void 0 ? void 0 : propertyDetails.bedrooms, " bds")
                                    }),
                                    (propertyDetails === null || propertyDetails === void 0 ? void 0 : propertyDetails.bathrooms) && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .Fragment */ .HY, {
                                        children: [
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__/* .Text */ .x, {
                                                tag: "span",
                                                typography: "$bodySmall",
                                                color: "$contentStateInactiveSecondary",
                                                children: " • "
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__/* .Text */ .x, {
                                                tag: "span",
                                                typography: "$bodySmall",
                                                color: "$contentTertiary",
                                                children: "".concat(propertyDetails === null || propertyDetails === void 0 ? void 0 : propertyDetails.bathrooms, " ba")
                                            })
                                        ]
                                    }),
                                    (propertyDetails === null || propertyDetails === void 0 ? void 0 : propertyDetails.sqFtTotalLiving) && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .Fragment */ .HY, {
                                        children: [
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__/* .Text */ .x, {
                                                tag: "span",
                                                typography: "$bodySmall",
                                                color: "$contentStateInactiveSecondary",
                                                children: " • "
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__/* .Text */ .x, {
                                                tag: "span",
                                                typography: "$bodySmall",
                                                color: "$contentTertiary",
                                                children: "".concat(propertyDetails === null || propertyDetails === void 0 ? void 0 : propertyDetails.sqFtTotalLiving.toLocaleString(), " sqft")
                                            })
                                        ]
                                    }),
                                    (propertyDetails === null || propertyDetails === void 0 ? void 0 : propertyDetails.dwellingType) && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .Fragment */ .HY, {
                                        children: [
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__/* .Text */ .x, {
                                                tag: "span",
                                                typography: "$bodySmall",
                                                color: "$contentStateInactiveSecondary",
                                                children: " • "
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__/* .Text */ .x, {
                                                tag: "span",
                                                typography: "$bodySmall",
                                                color: "$contentTertiary",
                                                children: (0,_property_helpers__WEBPACK_IMPORTED_MODULE_13__/* .convertDwellingType */ .F)(propertyDetails === null || propertyDetails === void 0 ? void 0 : propertyDetails.dwellingType)
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }, "map-marker-".concat(property.addressToken))
        ]
    });
};


/***/ }),

/***/ 40818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ MarketplaceMap; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_map_gl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61108);
/* harmony import */ var mapbox_gl_dist_mapbox_gl_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7609);
/* harmony import */ var mapbox_gl_dist_mapbox_gl_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(mapbox_gl_dist_mapbox_gl_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var components_marketplace_map_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98881);
/* harmony import */ var helpers_globals__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63631);






var MIN_ZOOM = 7;
var MAX_ZOOM = 17;
var MarketplaceMap = function(param) {
    var center = param.center, _dragPan = param.dragPan, dragPan = _dragPan === void 0 ? true : _dragPan, marketShape = param.marketShape, handleOnClick = param.handleOnClick, handleOnMapMove = param.handleOnMapMove, handleOnMoveEnd = param.handleOnMoveEnd, _showGeoLocationControls = param.showGeoLocationControls, showGeoLocationControls = _showGeoLocationControls === void 0 ? true : _showGeoLocationControls, mapMarkers = param.mapMarkers, mapRef = param.mapRef, zoom = param.zoom;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("grab"), cursor = ref[0], setCursor = ref[1];
    var handleMouseEnter = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        return setCursor("pointer");
    }, []);
    var handleMouseLeave = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        return setCursor("grab");
    }, []);
    var handleMouseDown = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        return setCursor("grabbing");
    }, []);
    // This means that if the user clicks on a cluster and the map re-renders with
    // a new cluster under their cursor, they will incorrectly see the "grab"
    // cursor rather than "grabbing", but it's much more efficient than monitoring
    // "mousemove" and continually polling for map features under the cursor
    var handleMouseUp = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        return setCursor("grab");
    }, []);
    var initialViewState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        if (center) {
            return {
                longitude: center[1],
                latitude: center[0],
                zoom: zoom || MIN_ZOOM
            };
        }
        if (marketShape === null || marketShape === void 0 ? void 0 : marketShape.coordinates) {
            try {
                return {
                    bounds: (0,components_marketplace_map_utils__WEBPACK_IMPORTED_MODULE_4__/* .getBoundsFromShape */ .J)(marketShape)
                };
            } catch (e) {
                return {
                    longitude: 0,
                    latitude: 0,
                    zoom: MIN_ZOOM
                };
            }
        }
        throw new Error("MarketplaceMap: Must provide either center, initialCoordinates, or marketShape");
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(react_map_gl__WEBPACK_IMPORTED_MODULE_1__/* .Map */ .D5, {
        ref: mapRef,
        mapboxAccessToken: helpers_globals__WEBPACK_IMPORTED_MODULE_3__/* .MAPBOX_ACCESS_TOKEN */ .A4,
        mapStyle: helpers_globals__WEBPACK_IMPORTED_MODULE_3__/* .MAPBOX_MAP_STYLE */ .Hx,
        onMove: handleOnMapMove,
        onMoveEnd: handleOnMoveEnd,
        interactiveLayerIds: [],
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onMouseDown: handleMouseDown,
        onMouseUp: handleMouseUp,
        cursor: cursor,
        style: {
            width: "100%",
            height: "100vh"
        },
        minZoom: zoom || MIN_ZOOM,
        maxZoom: MAX_ZOOM,
        initialViewState: initialViewState,
        fadeDuration: 0,
        onClick: handleOnClick,
        reuseMaps: true,
        dragPan: dragPan,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(react_map_gl__WEBPACK_IMPORTED_MODULE_1__/* .NavigationControl */ .Pv, {
                position: "top-left",
                showCompass: false
            }),
            showGeoLocationControls && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(react_map_gl__WEBPACK_IMPORTED_MODULE_1__/* .GeolocateControl */ .$j, {
                position: "top-right"
            }),
            mapMarkers
        ]
    });
};


/***/ }),

/***/ 98881:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ getBoundsFromShape; },
/* harmony export */   "a": function() { return /* binding */ getShapeFromMap; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36305);

var getBoundsFromShape = function(shape) {
    var _Math, _Math1, _Math2, _Math3;
    var type = shape.type, coordinates = shape.coordinates;
    if (!Array.isArray(coordinates)) {
        throw new Error("MarketShape coordinates must be a valid array");
    }
    var polygons;
    if (type === "Polygon") {
        polygons = coordinates[0];
    } else if (type === "MultiPolygon") {
        polygons = coordinates.flat(2);
    } else {
        polygons = null;
    }
    if (!Array.isArray(polygons) || polygons.length === 0) {
        throw new Error(type === "Polygon" || type === "MultiPolygon" ? "Invalid polygon coordinates" : "Unsupported GeoJSON shape type: ".concat(type));
    }
    var lngs = polygons.map(function(coord) {
        return coord.lon;
    });
    var lats = polygons.map(function(coord) {
        return coord.lat;
    });
    return [
        [
            (_Math = Math).min.apply(_Math, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(lngs)),
            (_Math1 = Math).min.apply(_Math1, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(lats))
        ],
        [
            (_Math2 = Math).max.apply(_Math2, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(lngs)),
            (_Math3 = Math).max.apply(_Math3, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(lats))
        ], 
    ];
};
var getShapeFromMap = function(map) {
    var bounds = map.getBounds();
    var vertices = [
        {
            lon: bounds.getNorthWest().lng,
            lat: bounds.getNorthWest().lat
        },
        {
            lon: bounds.getNorthEast().lng,
            lat: bounds.getNorthEast().lat
        },
        {
            lon: bounds.getSouthEast().lng,
            lat: bounds.getSouthEast().lat
        },
        {
            lon: bounds.getSouthWest().lng,
            lat: bounds.getSouthWest().lat
        },
        // The first and last points of a polygon must be identical
        {
            lon: bounds.getNorthWest().lng,
            lat: bounds.getNorthWest().lat
        }, 
    ];
    return vertices;
};


/***/ }),

/***/ 80284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ shared_MarketplaceMapLayout; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(46523);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/theme/ODThemeLite.mjs
var ODThemeLite = __webpack_require__(69666);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/cms/index.ts + 1 modules
var cms = __webpack_require__(96887);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/header/Header.tsx + 22 modules
var Header = __webpack_require__(12149);
// EXTERNAL MODULE: ./src/components/shared/GlobalStyles.tsx
var GlobalStyles = __webpack_require__(54991);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/footer/Footer.tsx
var Footer = __webpack_require__(62912);
;// CONCATENATED MODULE: ./src/components/shared/SharedContentfulFooter.tsx

// todo: refactor lpV2 footer

var DEFAULT_APPLE_STORE_LINK = "https://apps.apple.com/us/app/opendoor-buy-sell-homes/id1144498656";
var DEFAULT_GOOGLE_PLAY_LINK = "https://play.google.com/store/apps/details?id=com.opendoor.buyerapp&hl=en_US";
var DEFAULT_HELP_CENTER_LINK = "https://help.opendoor.com";
var SharedContentfulFooter = function(param) {
    var footer = param.footer, extraLegalText = param.extraLegalText, showCustomerTestimonialLegal = param.showCustomerTestimonialLegal, showEligibilityLegal = param.showEligibilityLegal, showPromotionLegal = param.showPromotionLegal, showThePdpCopyrightLegal = param.showThePdpCopyrightLegal;
    if (footer) {
        var ref, ref1;
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer["default"], {
            footerImage: (ref = footer.fields.footerImage) === null || ref === void 0 ? void 0 : ref.fields.file.url,
            footerTitle: footer.fields.footerTitle,
            footerImageTitle: (ref1 = footer.fields.footerImage) === null || ref1 === void 0 ? void 0 : ref1.fields.title,
            footerNav: footer.fields.footerNav,
            sellInYourMarket: footer.fields.sellInYourMarket,
            googlePlaystoreLink: footer.fields.googlePlaystoreLink || DEFAULT_GOOGLE_PLAY_LINK,
            appleStoreLink: footer.fields.appleStoreLink || DEFAULT_APPLE_STORE_LINK,
            helpCenterLink: footer.fields.helpCenterLink || DEFAULT_HELP_CENTER_LINK,
            backgroundColor: footer.fields.backgroundColor,
            extraLegalText: extraLegalText,
            showCustomerTestimonialLegal: showCustomerTestimonialLegal,
            showEligibilityLegal: showEligibilityLegal,
            showPromotionLegal: showPromotionLegal,
            showThePdpCopyrightLegal: showThePdpCopyrightLegal,
            locale: footer.sys.locale
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer["default"], {
        googlePlaystoreLink: DEFAULT_GOOGLE_PLAY_LINK,
        appleStoreLink: DEFAULT_APPLE_STORE_LINK,
        helpCenterLink: DEFAULT_HELP_CENTER_LINK,
        backgroundColor: "Grey"
    });
};
/* harmony default export */ var shared_SharedContentfulFooter = (SharedContentfulFooter);

;// CONCATENATED MODULE: ./src/components/properties/shared/MarketplaceMapLayout.tsx









var setHeight = "\n  html,\n  body,\n  div#__next {\n    height: 100%;\n  }\n";
var mainNavLinks = [
    {
        name: "How it works",
        href: "/how-it-works-sell"
    },
    {
        name: "Home insights",
        href: "/home-insights"
    },
    {
        name: "Browse homes",
        href: "/homes"
    }, 
];
var menuPanelNavLinks = [
    {
        name: "Work with a builder",
        href: "/builder"
    },
    {
        name: "Opendoor for Agents",
        href: "/agents"
    }, 
];
var MarketplaceMapLayout = function(param) {
    var children = param.children, header = param.header, footer = param.footer;
    var ref;
    var megaNavData = (header === null || header === void 0 ? void 0 : (ref = header.fields) === null || ref === void 0 ? void 0 : ref.mainNav) ? (0,cms/* transformHeaderNavToMegaNav */.$C)(header.fields.mainNav) : undefined;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ODThemeLite/* ThemedLite */.h, {
        baseTheme: "novo",
        team: "marketplace",
        launchDateString: new Date().toISOString(),
        overrides: {},
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "preconnect",
                        href: "https://images.opendoor.com"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "dns-prefetch",
                        href: "https://images.opendoor.com"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "preconnect",
                        href: "https://cdn-cosmos.opendoor.com"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "dns-prefetch",
                        href: "https://cdn-cosmos.opendoor.com"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                        httpEquiv: "X-UA-Compatible",
                        content: "IE=edge,chrome=1"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                        name: "viewport",
                        content: "width=device-width,initial-scale=1"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                        httpEquiv: "Accept-CH",
                        content: "DPR, Width, Viewport-Width"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "apple-touch-icon",
                        sizes: "144x144",
                        href: "https://www.opendoor.com/apple-touch-icon-144.png"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("style", {
                        children: setHeight
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GlobalStyles/* default */.Z, {
                fontWeights: [
                    "regular",
                    "semibold",
                    "bold",
                    "medium"
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                display: "flex",
                flexDirection: "column",
                height: "100%",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header/* default */.Z, {
                        slug: "homes",
                        mainNavLinks: mainNavLinks,
                        menuPanelNavLinks: menuPanelNavLinks,
                        megaNavData: megaNavData
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        tag: "main",
                        tabIndex: -1,
                        display: "flex",
                        overflow: "hidden",
                        backgroundColor: "$backgroundPrimary",
                        height: "calc(100% - 72px)",
                        children: children
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(shared_SharedContentfulFooter, {
                        footer: footer
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var shared_MarketplaceMapLayout = (MarketplaceMapLayout);


/***/ })

}]);